type LodOptionItem = {
  title: string;
  accessLevel: string;
  accessDepth: number;
}

type LodOptionsType = {
  free: LodOptionItem;
  premium: LodOptionItem;
}

export const LOD_OPTIONS: LodOptionsType = {
  free: {
    title: 'Standard',
    accessLevel: 'free',
    accessDepth: 5,
  },
  premium: {
    title: 'Full',
    accessLevel: 'premium',
    accessDepth: 15,
  },
};
